import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DivisionLookup, Divisions, GetDivisionsValue } from '../models';

export const divisionsActions = createActionGroup({
    source: 'Divisions',
    events: {
        'Get Divisions': props<{ value: GetDivisionsValue }>(),
        'Get Divisions Success': props<{ payload: Divisions }>(),
        'Get Divisions Error': props<{ code: number }>(),

        'Get Divisions Lookup': emptyProps(),
        'Get Divisions Lookup Success': props<{ payload: DivisionLookup[] }>(),
        'Get Divisions Lookup Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
